<form
  role="search"
  class="input-group"
  (submit)="onSearchValueChange.emit(searchValue); $event.preventDefault()">
  <input
    type="search"
    name="search-input"
    [(ngModel)]="searchValue"
    [placeholder]="placeholder"
    class="form-control">
  <button
    type="submit"
    id="search-button"
    aria-label="Търсене"
    class="btn btn-dark">
    <i class="me-2 fas fa-search" aria-hidden="true"></i>
    <span class="d-none d-sm-inline">Търсене</span>
  </button>
</form>
